export enum TransactionStatusMapEnum {
  Created = 'In process', // 0
  PendingForAuthorized  = 'In process', // 1
  Authorized = 'Authorized', // 2
  Posted = 'In process', // 3
  Captured = 'Captured', // 4
  Failed = 'Failed', // 5
  Returned = 'Returned', // 6
  Chargeback = 'Chargeback', // 7
  Cancelled = 'Voided', // 8
  Refunded = 'Refunded', // 9
  Approved = 'In process', // 10
  CancelAttempt = 'Void attempted', // 11
  RefundAttempt = 'Refund in process', // 12
  Hold = 'Hold', // 13
  Denied = 'Failed', // 14
  SettlementHold = 'Settlement hold', // 15
  Success = 'Settled', // 16
  Retried = 'Retried', //17
  ReprocessAttempt = 'Reprocess attempted', //18
  Reprocessed = 'Reprocessed', //19
  ChargebackReversed = 'Chargeback Reversed', //20
  RefundedReversed =  'Refunded Reversed', //21
  Paid =  'Paid', //22
  PaidChargeback =  'Paid Chargeback', //23
  PaidChargebackReversed = 'Paid Chargeback Reversed', //24
  PaidRefunded = 'Paid Refunded', //25
  PaidRefundedReversed = 'Paid Refunded Reversed', //26
  None = 'None', //99
  Unknown = 'Unknown', // 100
  accountnumber = 'ACCOUNT NUMBER',
  policynumber = 'POLICY NUMBER',
  invoicenumber = 'INVOICE NUMBER',
  other = 'OTHER',
  quoteid = 'QUOTE ID'
}

export enum RefundTransactionStatusMapEnum { 
  Refunded = 'Refunded',  
  RefundAttempt = 'Refund in process',   
  Success = 'Refund Settled',   
  RefundedReversed =  'Refunded Reversed',   
  PaidRefunded = 'Paid Refunded', 
  PaidRefundedReversed = 'Paid Refunded Reversed', 
  Failed = 'Failed', 
  Authorized = 'Refund Authorized',
}

export enum RefundTypeMapEnum {
  TotalRefund = '1',
  SubTotalRefund = '2',
  RemainingRefund = '3',
  PartialRefund = '4'
}